import { render } from "./EventCard.vue?vue&type=template&id=29a37352&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=29a37352&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29a37352"

export default script